<template>
  <el-dialog :title="title||'修改订单地址'" :visible.sync="show" width="700px" @close="cancelHandle">
    <el-form label-width="100px">
      <el-form-item label="收货人姓名">
        <el-input v-model="address.consignee" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="收货人电话">
        <el-input v-model="address.phone" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="选择省市区">
        <el-cascader
          :options="cityList"
          v-model="selectedOptions"
          :props="props"
          change-on-select
        ></el-cascader>
      </el-form-item>
      <el-form-item label="详细地址">
        <el-input v-model="address.address" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="clickHandle">确认</el-button>
        <el-button @click="cancelHandle">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>
import { Form, FormItem, Input, Button, Cascader, Dialog } from 'element-ui'
import cityList from '@/utils/data.city.js'
export default {
  name: 'EditLayer',
  components: {
    ElForm: Form,
    ElFormItem: FormItem,
    ElInput: Input,
    ElButton: Button,
    ElCascader: Cascader,
    ElDialog: Dialog
  },
  data () {
    return {
      show: false,
      cityList: cityList,
      title: '',
      action: '',
      address: {
        consignee: '', // 收货人姓名
        phone: '', // 收货人电话
        province: '', // 省
        city: '', // 市
        district: '', // 区
        address: '' // 详细地址
      },
      selectedOptions: ['', '', ''],
      props: {
        value: 'text',
        label: 'text',
        children: 'children'
      },
      time: null // 定时器
    }
  },
  methods: {
    showLayer (options, title) {
      this.action = ''
      this.title = title || ''
      this.show = true
      if (options) {
        this.address.consignee = options.consignee
        this.address.phone = options.phone
        this.address.province = options.province
        this.address.city = options.city
        this.address.district = options.district
        this.address.address = options.address

        this.selectedOptions = [ options.province, options.city, options.district ]
      }

      return new Promise((resolve, reject) => {
        this.time = setInterval(_ => {
          if (this.action === 'success') {
            let myreg = /^[1][3,4,5,7,8][0-9]{9}$/
            if (!myreg.test(this.address.phone)) {
              this.action = ''
              this.$message.error('请输入有效的手机号码!')
              return
            }
            this.address.province = this.selectedOptions[0]
            this.address.city = this.selectedOptions[1]
            this.address.district = this.selectedOptions[2]
            resolve(this.address)
            this.show = false
            clearInterval(this.time)
          }
          if (this.action === 'cancel') {
            reject(new Error('handle cancel'))
            clearInterval(this.time)
            this.show = false
          }
        }, 100)
      })
    },
    clickHandle () {
      this.action = 'success'
    },
    cancelHandle () {
      this.action = 'cancel'
    }
  }
}
</script>
<style lang="less" scoped>
.content {
  width: 700px;
  h3 {
    text-align: center;
    margin-bottom: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AddressSelect/AddressSelect.vue